import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType, ApplicationSearchInteractionType } from '../constants';

export class SearchInteractionApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.SearchInteraction;

  constructor(private interactionType: ApplicationSearchInteractionType) {

  }

  getPayload(): any {
    return {
      type: this.interactionType
    };
  }
}
